import * as React from "react";
import Text from "@warda/library-ui/core/Text";
import { Initialize } from "@warda/library-ui/interfaces";
import { getTheme } from "@warda/library-ui/theme";
import apiUrls from "../../api/apiUrlsAnonymous";
import { getTenantId } from "./constants";
const TenantLogo = ({ className, style, onLogoReady }) => {
    const tenantId = getTenantId();
    const [init, setInit] = React.useState(Initialize.WAIT);
    const onLoad = React.useCallback(() => {
        setInit(Initialize.SUCC);
        onLogoReady === null || onLogoReady === void 0 ? void 0 : onLogoReady();
    }, [onLogoReady]);
    const onError = React.useCallback(() => {
        setInit(Initialize.FAIL);
        onLogoReady === null || onLogoReady === void 0 ? void 0 : onLogoReady();
    }, [onLogoReady]);
    if (init === Initialize.FAIL) {
        return (React.createElement(Text, { className: className, style: {
                ...style,
                margin: "0 10px",
                fontSize: 25,
                color: getTheme().colors.theme1,
            }, children: "SeeCommerce" }));
    }
    return (React.createElement("img", { className: className, style: { ...style, height: 25 }, src: apiUrls.getLogoTenant.url(tenantId), alt: "", onLoad: onLoad, onError: onError }));
};
export default TenantLogo;
